export default __webpack_public_path__ + "static/award-1-f501760872ba084e4db18b4b02c7ddb0.png";